import type { DictionaryRoster } from '@/api/types/dictionary'

/** Flattens the roster into single words: "Mary Ann" and "Smith-Jones" become separate entries. */
export function rosterWords(roster: DictionaryRoster | undefined): string[] {
  if (!roster) return []

  return [...roster.firstNames, ...roster.lastNames].flatMap((name) =>
    name.split(/[\s-]+/).filter(Boolean)
  )
}
